/**************************************************
 * Nombre:       Detalle_Imgs_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import prod from '../../../../Recursos/Temporales/tmp_prod.png'
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {useRef} from "react";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Detalle_Imgs_Producto = () => {
    const {sCell} = useResponsive()
    const refe = useRef()

    const atras = () => {
        if (refe.current) {
            refe.current.splide.go('<'); // Mueve al slide anterior
        }
    };

    const adelante = () => {
        if (refe.current) {
            refe.current.splide.go('>'); // Mueve al slide siguiente
        }
    };

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            direction={'row-reverse'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Splide
                    ref={refe}
                    aria-label="My Favorite Images"
                    options={{
                        autoplay: true,
                        speed: 3000,
                        rewind: true,
                        arrows: false,
                        pagination: true,
                        width: '100%',
                        drag: false,
                        interval: 10000,
                        noDrag: true,
                        type: 'fade',


                    }}
                >

                    {items.map((item, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <img src={prod} width={'100%'} height={'auto'}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 2}}
                spacing={2}
                sx={{mt: sCell ? 2 : 0}}
            >

                {imgs.map((it, index) => {
                    return (
                        <Grid container size={{xs: 3, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <img src={prod} width={'100%'} height={'auto'}/>
                        </Grid>
                    )
                })}

            </Grid>


        </Grid>
    )

}
export default Detalle_Imgs_Producto

const imgs = [1, 2, 3, 4]

const items = [1, 2, 3, 4]